<template>
  <div class="face-forms">
    <van-form @submit="onSubmit">
      <van-field
        readonly
        clickable
        :value="typeName"
        name="type"
        label="选择班型"
        placeholder="请选择班型"
        clearable
        clear-trigger="always"
        @click="classShow = true"
        :rules="[{ required: true, message: '' }]"
      />
      <van-popup v-model="classShow" position="bottom">
        <van-picker title="选择班型" show-toolbar :columns="classColumns" value-key="name" @confirm="elseConfirm($event, 'type', 'class')" @cancel="classShow = false" />
        <!-- @confirm="classConfirm($event)" -->
      </van-popup>
      <van-field
        readonly
        clickable
        name="picker"
        :value="cityIdName"
        label="选择校区"
        placeholder="请选择校区"
        @click="cityShow = true"
        :rules="[{ required: true, message: '' }]"
      />
      <van-popup v-model="cityShow" position="bottom">
        <van-picker title="选择校区" show-toolbar :columns="cityColumns" value-key="name" @confirm="elseConfirm($event, 'cityId', 'city')" @cancel="cityShow = false" />
        <!-- cityConfirm -->
      </van-popup>
      <van-field
        readonly
        clickable
        name="picker"
        :value="courseIdName"
        label="报名学科"
        placeholder="请选择报名学科"
        @click="courseIdShow = true"
        :rules="[{ required: true, message: '' }]"
      />
      <van-popup v-model="courseIdShow" position="bottom">
        <van-picker
          title="选择学科"
          show-toolbar
          value-key="name"
          :columns="subjectColumns"
          @confirm="elseConfirm($event, 'courseId', 'courseId')"
          @cancel="courseIdShow = false"
        />
        <!-- subjectConfirm -->
      </van-popup>
      <van-field
        readonly
        clickable
        name="picker"
        :value="timeName"
        label="报名时间"
        placeholder="请选择报名时间"
        @click="timeShow = true"
        :rules="[{ required: true, message: '' }]"
      />
      <van-popup v-model="timeShow" position="bottom">
        <van-picker title="选择报名时间" show-toolbar value-key="combination" :columns="timeColumns" @confirm="timeConfirm" @cancel="timeShow = false" />
      </van-popup>
      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">查询</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { studentPayYears, searchInfo, getAllCity, getcourseAllCourseList, selectTuitionConfig } from "@/server/api.js";
import { Toast } from "vant";
export default {
  data() {
    return {
      showPicker: false,
      yearItem: "",
      filter: {
        type: "",
        cityId: "",
        beginMonth: "",
        endMonth: "",
        courseId: "",
      },
      typeName: "",
      timeName: "",
      courseIdName: "",
      cityIdName: "",
      classShow: false,
      cityShow: false,
      courseIdShow: false,
      timeShow: false,
      columns: [],
      classColumns: [
        // {
        //   id: 1,
        //   name: "好程序员",
        // },
        {
          id: 2,
          name: "AI芯源",
        },
      ],
      cityColumns: [],
      subjectColumns: [],
      timeColumns: [],
      resultList: [],
    };
  },
  mounted() {
    this.cityList();
    this.cityCourseList();
    this.timeList();
  },
  methods: {
    onSubmit() {
      selectTuitionConfig(this.filter).then((res) => {
        if (res.code !== "200") {
          this.$emit("search", []);
          Toast.fail(res.msg);
        } else {
          this.$emit("search", res.data);
        }
      });
    },
    tabChange(name) {
      this.activeTab = name;
    },
    timeList() {
      studentPayYears({}).then((res) => {
        res.data.map((v) => {
          v.combination = v.beginMonth.slice(0, 7) + " 至 " + v.endMonth.slice(0, 7);
        });
        this.timeColumns = res.data;
      });
    },
    //获取选择校区
    cityList() {
      // searchInfo().then((res) => {
      //   this.cityColumns = res.data.cityList;
      //   this.subjectColumns = res.data.courseList;
      // });
      getAllCity().then((res) => {
        this.cityColumns = res.data;
      });
    },
    //获取选择学科
    cityCourseList() {
      getcourseAllCourseList().then((res) => {
        this.subjectColumns = res.data;
      });
    },
    elseConfirm(item, name, popup) {
      // popup+show是弹框的开发
      this[name + "Name"] = item.name;
      this.filter[name] = item.id;
      this[popup + "Show"] = false;
    },
    timeConfirm(value) {
      this.timeName = value.combination;
      this.filter.beginMonth = value.beginMonth ? value.beginMonth : "";
      this.filter.endMonth = value.endMonth ? value.endMonth : "";
      this.timeShow = false;
    },
  },
};
</script>
<style scoped lang="less">
.face-forms {
  /deep/.van-form .van-cell {
    padding-left: 0;
  }
  /deep/.van-cell::after {
    left: 0;
  }
  /deep/.van-field__control::-webkit-input-placeholder {
    font-size: 26px;
  }
  /deep/.van-picker__title {
    font-size: 26px;
    height: 40px;
    line-height: 40px;
  }
}
</style>
